require('./debugger.tpl.html');
require('./debuggerController');
require('./debuggerDirective');

require('./dragAndDrop/dragAndDropComponent');

const DebuggerComponent = {
    templateUrl: '/formViewer/debug/debugger.tpl.html',
    controller: 'debuggerController',
    bindings: {
        formName: '<'
    }
};

angular.module('umFormViewer')
    .component('umFormViewerDebugger', DebuggerComponent);
